import { user } from '@repo/ui'
import { account, impersonatedAccount } from '@store/account'
import { derived } from 'svelte/store'

export const displayName = derived(
	[user, account, impersonatedAccount],
	([$user, $account, $impersonatedAccount]) => {
		return $impersonatedAccount?.name || $account?.name || $user?.displayName || $user?.email
	},
)
